import { Box } from '@mui/material';

import { colors } from 'src/global/styles/colors';

import { ThemeEditorTabs } from './ThemeEditorTabs';

export function ThemeEditor() {
  return (
    <Box width={'100%'} marginTop={3} borderRadius={1} border={`1px solid ${colors.neutral015}`}>
      <ThemeEditorTabs />
    </Box>
  );
}
